import { z } from 'zod'

// Absent means unmeasured, not healthy. Each Test Run owns its own flags.
export const TestRunFlagsSchema = z.object({
  missing_sourcemaps: z.boolean().optional(),
})
export type TestRunFlags = z.infer<typeof TestRunFlagsSchema>
